import { render, staticRenderFns } from "./see-handleContent.vue?vue&type=template&id=1cf1fb87&"
import script from "./see-handleContent.vue?vue&type=script&lang=ts&"
export * from "./see-handleContent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports